import { render } from "./recruitmentReason.vue?vue&type=template&id=66402ac0&ts=true"
import script from "./recruitmentReason.vue?vue&type=script&lang=ts"
export * from "./recruitmentReason.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.4.21_typescript@5.9.3__webpack@5.105.4_@swc+core@1.15.8_esbuild@0.27.2_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__